import React from 'react';
import { Shimmer as PPShimmer } from '@paypalcorp/pp-react';

/**
 * Shimmer Loading Component for Venmo Payment Button
 *
 * This component displays a loading shimmer effect while the PayPal SDK
 * and Venmo payment button are initializing. It provides visual feedback
 * to users that the payment option is loading, improving the user experience
 * by preventing layout shifts and indicating that content is coming.
 *
 * The shimmer matches the expected height of the Venmo payment button (45px)
 * to maintain consistent layout during the loading state.
 *
 * @returns {React.Component} A shimmer loading animation component
 */
const Shimmer = () => {
  return (
    <div className="venmo-shimmer">
      {/* PayPal React shimmer component with test identifier for testing */}
      <PPShimmer data-testid="loading-shimmer"></PPShimmer>
    </div>
  );
};

export default Shimmer;
